module.exports = __webpack_public_path__ + "static/media/logo.ca80ccd1.svg";